var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.savedPercent)?_c('span',{staticClass:"opc-price-save-count",class:{
  'opc-price-save-count__disabled': _vm.disabled
}},[_vm._v(_vm._s(_vm.$t('billing.common.save_count', [_vm.savedPercent])))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }